<template>
  <ImageUpload
    :isPublic="isPublic"
    :disabled="disabled"
    @imageUploaded="handleImageUploaded"
  >
    <template slot-scope="{ isDraggingFile, isUploading, selectFile }">
      <div
        class="uploader"
        :class="{
          'uploader--dragging': isDraggingFile,
          'uploader--disabled': disabled,
        }"
        :data-tourid="tourId"
        @click="selectFile"
      >
        <WidgetLoader :show="isUploading" />
        <em v-if="!isUploading" class="material-icons uploader__icon"
          >insert_photo</em
        >
      </div>
    </template>
  </ImageUpload>
</template>

<script>
export default {
  name: 'EditMode',

  props: {
    tourId: {
      type: String,
      required: false,
      default: 'photoSelector',
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    isPublic: {
      type: Boolean,
      default: false,
      required: false,
    },
    showEditor: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  components: {
    ImageUpload: () => import('@/components/utils/ImageUpload'),
    WidgetLoader: () => import('@/components/Widgets/WidgetLoader'),
  },

  methods: {
    handleImageUploaded(data) {
      this.$emit('imageUploaded', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  background: $color-blue-grey-lighten3;
  border: 1px dashed $color-blue-grey-lighten1;
  border-radius: 4px;
  cursor: pointer;

  &--disabled {
    opacity: 0.4;
  }

  &--dragging:not(&--disabled) {
    background-color: $color-blue-grey-lighten3;
    border: 1px dashed $color-blue-grey-lighten1;

    * {
      pointer-events: none;
    }
  }

  &__icon {
    color: $color-blue-grey-darken3;
    font-size: 40px;
  }
}
</style>
